import script from "./OperateLogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperateLogs.vue?vue&type=script&lang=ts&setup=true"

import "./OperateLogs.vue?vue&type=style&index=0&id=4898c951&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4898c951"]])

export default __exports__